import "./MediaHub.module.css";
import Header from "@/reusable_sections/Header";
import YoutubeIntelligence from "./sections/YoutubeIntelligence";
import Latestyoutubevideos from "./sections/Latestyoutubevideos";
import SocialStream from "./sections/SocialStream";
import YouTubeCreatorAwards from "./sections/YouTubeCreatorAwards";
import Footer from "@/reusable_sections/Footer";
export default function MediaHubPage() {
  return <div>
      <Header />
      <YoutubeIntelligence />
      <YouTubeCreatorAwards />
      <Latestyoutubevideos />
      <SocialStream />
      <Footer />
    </div>;
}